function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rectangle-path");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 30,
  height: 30
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 12,
  height: 12
}));

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "7.2 2.52821053 9 0.00189473684 6 0.00189473684 4.2 2.52821053"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "10.8 0.00189473684 9 2.52821053 13.2 2.52821053 13.2 0.00189473684"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "4.2 0.00189473684 0 0.00189473684 0 2.52821053 2.4 2.52821053"
});

var SvgIconArticleTextVideo = function SvgIconArticleTextVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Academy-V1.2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-75.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-Academy-V2-Copy-2",
    transform: "translate(40.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-list",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-video-and-article",
    transform: "translate(30.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-newspaper-1",
    transform: "translate(5.000000, 5.000000)"
  }, _ref5, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M27,17.1000061 L15.5999756,17.1000061 L15.5999756,27.2631579 L4.26315789,27.2631579 C3.56463158,27.2631579 3,26.6972632 3,26 L3,3.26315789 C3,2.56589474 3.56463158,2 4.26315789,2 L25.7368421,2 C26.4353684,2 27,2.56715789 27,3.26315789 L27,17.1000061 Z M14.3684211,23.4736842 L14.3684211,20.9473684 L6.78947368,20.9473684 L6.78947368,23.4736842 L14.3684211,23.4736842 Z M14.3684211,19.6842105 L14.3684211,17.1578947 L6.78947368,17.1578947 L6.78947368,19.6842105 L14.3684211,19.6842105 Z M14.3684211,15.896 L14.3684211,13.3696842 L6.78947368,13.3696842 L6.78947368,15.896 L14.3684211,15.896 Z M23.2105263,15.896 L23.2105263,13.3696842 L15.6315789,13.3696842 L15.6315789,15.896 L23.2105263,15.896 Z M23.2105263,9.58021053 L23.2105263,5.79073684 L6.78947368,5.79073684 L6.78947368,9.58021053 L23.2105263,9.58021053 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clapboard-play",
    transform: "translate(17.000000, 18.000000)"
  }, _ref6, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(0.000000, 0.500000)",
    fill: "#C7E3FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _ref7, _ref8, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M0,10.1071579 C0,10.8050526 0.537,11.3703158 1.2,11.3703158 L12,11.3703158 C12.6624,11.3703158 13.2,10.8050526 13.2,10.1071579 L13.2,3.79136842 L0,3.79136842 L0,10.1071579 Z M5.4,5.05452632 L9,7.58084211 L5.4,10.1071579 L5.4,5.05452632 Z",
    id: "Shape"
  }), _ref9)))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArticleTextVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-article-text-video.b222dc21.svg";
export { ForwardRef as ReactComponent };